/*
 * サブシステム名：経営管理
 * 機能名：傭車別支払金額管理
 */
import DdDefaultButton from '@/components/DdDefaultButton'
import DdIconButton from '@/components/DdIconButton'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdTextBox from '@/components/DdTextBox'
import DdCheckbox from '@/components/DdCheckbox'
import DdNumericBox from '@/components/DdNumericBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdEditDialog from '@/components/DdEditDialog'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox.vue'
import DdRowCountBox from '@/components/DdRowCountBox.vue'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import tax from '@/ddv2.library/tax'
import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

export default {
  name: 'YoshabetsuShiharaiKingakuKanri',
  mixins: [flowMixin],
  data: () => ({
    kamotsuHeaders: [],
    expansionPanel: [0, 1],
    id: 1,
    // 権限
    modeKengen: 0,
    modeOfEdit: 0,
    conditions: {
      shiharaiStartYmdString: '',
      shiharaiEndYmdString: '',
      seikyuStartYmdString: '',
      seikyuEndYmdString: '',
      torihikisakiCd: '',
      minyuryokuFlg: false,
      eigyoshoCd: '',
      ninushiCd: '',
      chakuchiCd: ''
    },
    EditMode: false,
    editButtonDisplay: false,
    summaryShiharaiUnchin: 0,
    summaryTsukoryo: 0,
    summaryZeinuki: 0,
    summaryHikazei: 0,
    summaryAll: 0,
    searchText: '',
    // 表示用
    selectedItemKamotsu: [],
    // チェックボックス制御
    selectedItemKamotsuCheck: [],
    // ヘッダリスト
    headersYoshasakiList: header.mstTorihikisakiHeaders,
    headersNinushiList: header.mstTorihikisakiHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersChakuchiList: header.mstHacchakuchiHeaders,
    page: 1,
    isCsvDownloader: false
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdIconButton,
    DdCodeTextBox,
    DdDateBox,
    DdTextBox,
    DdCheckbox,
    DdNumericBox,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdEditDialog,
    DdFooterButton,
    DdDataTable
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyoshoCd: 'users/eigyoshoCd',
      yoshasakiList: 'DDMasters/mstTorihikisaki',
      ninushiList: 'DDMasters/mstTorihikisaki',
      chakuchiList: 'DDMasters/mstHacchakuchi'
    }),
    // 傭車先
    filteredYoshasakiList () {
      const target = filter.dateFormatter(new Date())
      return this.yoshasakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.hacchusakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 荷主
    filteredNinushiList () {
      const target = filter.dateFormatter(new Date())
      return this.ninushiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    // 着地
    filteredChakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.chakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.chakuchiCd > elem2.chakuchiCd) { return 1 }
        if (elem1.chakuchiCd === elem2.chakuchiCd) { return 0 }
        return -1
      })
    },
    // 検索結果
    rowCountCustom () {
      var cnt = 0
      if (Object.keys(this.rows).length === 0) {
      } else {
        if (this.rows.length !== 0 && this.rows.kamotsu !== null) {
          cnt = this.rows.kamotsu.length
        }
      }
      return cnt
    },
    // 絞り込み結果
    filteredRowCountCustom () {
      var cnt = 0
      if (!Object.keys(this.rows) && Object.keys(this.rows).length === 0) {
      } else {
        if (Object.keys(this.rows).length !== 0 && this.rows.length !== 0 && this.rows.kamotsu !== null) {
          const items = this.kamotsuHeaders.map(h => h.value)
          const text = this.searchText
          const length = this.rows.kamotsu.filter(r => {
            for (let i = 0; i < items.length; i++) {
              const hit = this.filtering(r[items[i]], text, r)
              if (hit) { return true }
            }
            return false
          }).length
          return length
        }
      }
      return cnt
    },
    // 照会モード
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    // 編集モード
    isEditMode () {
      return this.EditMode
    },
    // 参照モード
    isPrevMode () {
      return !this.EditMode
    },
    // 保存ボタン制御
    isSaveButtonDisabled () {
      return this.rowCountCustom === 0
    },
    // ボタン表示非表示
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    }
  },
  created () {
    this.initialize()
  },
  mounted () {
  },
  methods: {
    // 初期値クローン
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    filtering (value, search, item) {
      return this.Filters.filter(value, search, item)
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msystax', 'msteigyosho', 'msttorihikisaki', 'msthacchakuchi'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.kamotsuHeaders = [
              { text: '営業所', value: 'eigyoshoNm', width: '10vh' },
              { text: '傭車先', value: 'yoshaNm', width: '10vh' },
              { text: '支払計上日', value: 'shiharaiYoteiYmd', width: '10vh' },
              { text: '請求予定日', value: 'seikyuYoteiYmd', width: '10vh' },
              { text: '貨物No', value: 'kamotsuNo', width: '10vh' },
              { text: '荷主', value: 'ninushiNm', width: '10vh' },
              { text: '着地', value: 'chakuchiNm', width: '10vh' },
              { text: '日報No', value: 'nippoNo', width: '10vh' },
              { text: '支払運賃', value: 'shiharaiUnchin', width: '10vh', align: 'right' },
              { text: '支払通行料', value: 'tsukoryo', width: '10vh', align: 'right' },
              { text: '支払税抜き額', value: 'zeinuki', width: '10vh', align: 'right' },
              { text: '支払非課税分', value: 'hikazei', width: '10vh', align: 'right' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          console.log('■initializeInputPromise')
          // 入力内容初期化
          return new Promise((resolve) => {
            self.rows = {}
            var dt = new Date()
            self.conditions.shiharaiStartYmdString = self.getDateYmdString(dt, 1)
            self.conditions.shiharaiEndYmdString = self.getDateYmdString(dt, 99)
            self.conditions.seikyuStartYmdString = ''
            self.conditions.seikyuEndYmdString = ''
            self.conditions.eigyoshoCd = self.usersEigyoshoCd
            self.conditions.torihikisakiCd = ''
            self.conditions.ninushiCd = ''
            self.conditions.chakuchiCd = ''
            self.dataClear()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            resolve()
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        // 権限によるボタン制御
        // 表示モードによるボタン制御
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }

      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForViewer(option)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/Thbzmd0020/SearchChildren', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          if (data.isValid) {
            self.rows = data.payload
            if (self.rows !== null) {
              this.editButtonDisplay = true
              // 【貨物】
              self.rows.kamotsu = self.rows.kamotsu.map((kamotsu) => {
                // 非課税分
                kamotsu.hikazei = kamotsu.userKingakuHikazei1
                // 各項目フォーマット
                kamotsu = self.kamotsuFormat(kamotsu)
                return kamotsu
              })
              // 再計算
              self.reCalc()
              self.rows.kamotsu.unshift('dummy')
              self.rows.kamotsu.splice(0, 1)
            } else {
              self.dataClear()
            }
          }
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            // ユーザ保存項目 なし
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            var dt = new Date()
            this.conditions = {
              shiharaiStartYmdString: this.getDateYmdString(dt, 1),
              shiharaiEndYmdString: this.getDateYmdString(dt, 99),
              seikyuStartYmdString: this.getDateYmdString(dt, 1),
              seikyuEndYmdString: this.getDateYmdString(dt, 99),
              torihikisakiCd: '',
              eigyoshoCd: this.usersEigyoshoCd,
              ninushiCd: '',
              chakuchiCd: ''
            }
            this.editButtonDisplay = false
            this.EditMode = false
            this.searchText = ''
            this.dataClear()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    // CSVボタン
    onCsvButtonClick: function (e) {
      this.isCsvDownloader = true
      this.HttpClient
        .post('/api/v1/Thbzmd0020/CsvDownload', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          this.isCsvDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    // 保存ボタン
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            this.onSearchButtonClick()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.id = id
            // self.transition(0, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.rows.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      const self = this
      var meisaiArr = self.selectedItemKamotsu.filter(kamotsuMeisai => kamotsuMeisai.id !== null)
      var updateList = {}

      // 貨物情報設定（明細に紐づく金額設定）
      meisaiArr.map((kamotsu) => {
        // ID
        kamotsu.id = kamotsu.hacchuKingakuId
        // 請求運賃 ⇒ 基本運賃
        kamotsu.kihonUnchin = kamotsu.shiharaiUnchin
        // 通行料
        kamotsu.hiwayPrice = kamotsu.tsukoryo
        // 非課税分
        kamotsu.userKingakuHikazei1 = kamotsu.hikazei
        return kamotsu
      })

      // 最終行に追加
      updateList.TrKamotsuKingakuList = meisaiArr

      // 更新モード固定
      const f = self.HttpClient.post('/api/v1/Thbzmd0020/UpdateMulti?id=1', updateList)
      return f
    },
    validateRows: function (e) {
      return true
    },
    registerValidate: function () {
      return true
    },
    // shurui 0:日付 1:時刻 2:数値
    dataFormatter: function (item, shurui) {
      if (item !== null) {
        switch (shurui) {
          case 0:
            // 日付
            return filter.dateFormatter(item)
          case 1:
            // 時刻
            return item.slice(0, 5)
          case 2:
            if (isFinite(item)) {
              // 数値
              return filter.numericFormatter(Number(item))
            } else {
              return item
            }
        }
      }
    },
    // 貨物金額
    kingakuSaveKamotsu: function (e, row) {
      if (e === true && isFinite(this.getNullValue(row.value))) {
        // 貨物
        row.item = this.kamotsuFormat(row.item)
        const dtArr = this.selectedItemKamotsu.filter(item => item.hacchuKingakuId === row.item.hacchuKingakuId)
        if (dtArr.length === 0) {
          // 追加
          this.selectedItemKamotsu.push(row.item)
          this.selectedItemKamotsuCheck.push(row.item, true)
        } else {
          // 更新
          const targetItem = this.selectedItemKamotsu.findIndex((rec) => rec.hacchuKingakuId === row.item.hacchuKingakuId)
          this.selectedItemKamotsu.splice(targetItem, 1, row.item)
        }
      } else {
        this.selectedItemKamotsu = this.selectedItemKamotsu.filter(item => item.hacchuKingakuId !== row.item.hacchuKingakuId)
      }
      // 再計算
      this.reCalc()
    },
    // チェック：強制OFF
    itemSelectKamotsu: function (e) {
      this.selectedItemKamotsuCheck.push(e, false)
    },
    onEditButtonClick: function (e) {
      this.EditMode = true
    },
    onPrevButtonClick: function (e) {
      this.EditMode = false
    },
    searchValidate: function () {
      var msg = validators.compareDate(this.conditions.shiharaiStartYmdString, this.conditions.shiharaiEndYmdString)
      if (msg !== undefined) {
        this.$refs.shiharaiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.shiharaiEndString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      msg = validators.compareDate(this.conditions.shiharaiStartYmdString, this.conditions.shiharaiEndYmdString)
      if (msg !== undefined) {
        this.$refs.shiharaiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.shiharaiEndString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      msg = validators.compareDate(this.conditions.seikyuStartYmdString, this.conditions.seikyuEndYmdString)
      if (msg !== undefined) {
        this.$refs.seikyuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.seikyuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      return true
    },
    // datatable関連クリア
    dataClear: function () {
      this.rows = []
      this.summaryShiharaiUnchin = 0
      this.summaryTsukoryo = 0
      this.summaryZeinuki = 0
      this.summaryHikazei = 0
      this.summaryAll = 0
      this.selectedItemKamotsu = []
      this.selectedItemKamotsuCheck = []
    },
    // 全部再計算
    reCalc: function () {
      // 支払運賃
      this.calcSummaryShiharaiUnchin()
      // 通行料(税抜)
      this.calcSummaryTsukoryo()
      // 税抜き
      this.calcSummaryZeinuki()
      // 非課税分
      this.calcSummaryHikazei()
      // 合計
      this.calcSummaryAll()
    },
    // 支払運賃計
    calcSummaryShiharaiUnchin: function (item) {
      var shiharaiUnchinSummary = 0
      this.rows.kamotsu.map((kamotsu) => {
        shiharaiUnchinSummary = this.getNullValue(shiharaiUnchinSummary) + this.getNullValue(kamotsu.shiharaiUnchin)
        return shiharaiUnchinSummary
      })
      this.summaryShiharaiUnchin = shiharaiUnchinSummary
    },
    // 通行料計
    calcSummaryTsukoryo: function (item) {
      var tsukoryoSummary = 0
      this.rows.kamotsu.map((kamotsu) => {
        tsukoryoSummary = this.getNullValue(tsukoryoSummary) + this.getNullValue(kamotsu.tsukoryo)
        return tsukoryoSummary
      })
      this.summaryTsukoryo = tsukoryoSummary
    },
    // 税抜き計
    calcSummaryZeinuki: function (item) {
      var zeinukiSummary = 0
      this.rows.kamotsu.map((kamotsu) => {
        zeinukiSummary = this.getNullValue(zeinukiSummary) + this.getNullValue(kamotsu.zeinukiHidden)
        return zeinukiSummary
      })
      this.summaryZeinuki = zeinukiSummary
    },
    // 非課税計
    calcSummaryHikazei: function (item) {
      var hikazeiSummary = 0
      this.rows.kamotsu.map((kamotsu) => {
        hikazeiSummary = this.getNullValue(hikazeiSummary) + this.getNullValue(kamotsu.hikazei)
        return hikazeiSummary
      })
      this.summaryHikazei = hikazeiSummary
    },
    // 合計
    calcSummaryAll: function (item) {
      this.summaryAll = this.getNullValue(this.summaryShiharaiUnchin) +
      // this.getNullValue(this.summaryTsukoryo) +
      this.getNullValue(this.summaryZeinuki) +
      this.getNullValue(this.summaryHikazei)
    },
    // shubetsu 1:月初 99:月末
    getDateYmdString: function (dt, shubetsu) {
      var result
      if (shubetsu === 1) {
        // 月初
        result = new Date(dt.getFullYear(), dt.getMonth(), 1)
      } else {
        // 月末
        result = new Date(dt.getFullYear(), dt.getMonth() + 1, 0)
      }
      return filter.dateFormatter(result)
    },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return 0 }
      if (inputValue === undefined) { return 0 }
      if (inputValue === '') { return 0 }
      return this.getSanitizedValue(inputValue)
    },
    // 貨物関連フォーマット
    kamotsuFormat (kamotsu) {
      var taxKijunDate = this.dataFormatter(kamotsu.shiharaiYoteiYmd, 0)
      kamotsu.shiharaiYoteiYmd = this.dataFormatter(kamotsu.shiharaiYoteiYmd, 0)
      kamotsu.seikyuYoteiYmd = this.dataFormatter(kamotsu.shiharaiYoteiYmd, 0)
      kamotsu.shiharaiUnchin = this.dataFormatter(this.getNullValue(kamotsu.shiharaiUnchin), 2)
      kamotsu.tsukoryo = this.dataFormatter(this.getNullValue(kamotsu.tsukoryo), 2)
      kamotsu.zeinuki = this.dataFormatter(tax.calcWithoutTax5u6d(this.getNullValue(kamotsu.tsukoryo), taxKijunDate), 2)
      kamotsu.zeinukiHidden = this.dataFormatter(tax.calcWithoutTax5u6d(this.getNullValue(kamotsu.tsukoryo), taxKijunDate), 2)
      kamotsu.hikazei = this.dataFormatter(this.getNullValue(kamotsu.hikazei), 2)
      return kamotsu
    },
    // カンマ除去
    getSanitizedValue (inputVal) {
      if (typeof inputVal === 'string' && inputVal !== '') {
        var retVal = inputVal.replaceAll(',', '')
        if (isFinite(retVal)) {
          return parseFloat(retVal)
        } else {
          return ''
        }
      }
      return inputVal
    }
  }
}
